import { createFileRoute } from "@tanstack/react-router";
import { PublicDocumentPage } from "../components/PublicDocumentPage";

export const Route = createFileRoute("/q/$token")({
  component: PublicQuotePage,
});

function PublicQuotePage() {
  const { token } = Route.useParams();
  return <PublicDocumentPage kind="quote" token={token} />;
}
